import { toAbsoluteUrl } from "src/_metronic/helpers/AssetHelpers";
import SVG from "react-inlinesvg";
import { CellLinks } from "src/app/components";

export function indexColumn() {
    return {
        filter: "agSetColumnFilter",
        valueGetter: ({ data }: any) => {
            return data?.indexed;
        },
        cellRenderer: (params: { data: any }) => {
            const { data } = params;
            if (data?.indexed === 0) {
                return (
                    <SVG
                        src={toAbsoluteUrl("/media/icons/duotune/general/gen034.svg")}
                        className="svg-icon-danger"
                    />
                );
            }
            if (data?.indexed === 1) {
                return (
                    <SVG
                        src={toAbsoluteUrl("/media/icons/duotune/general/gen037.svg")}
                        className="svg-icon-valid"
                    />
                );
            }
            if (data?.indexed === 2) {
                return (
                    <SVG
                        src={toAbsoluteUrl("/media/icons/duotune/general/gen046.svg")}
                        className="svg-icon-warning"
                    />
                );
            }
        },
        filterParams: {
            cellRenderer: (params: { value: any }) => {
                const value = params.value;
                if (value === "0") {
                    return (
                        <SVG
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen034.svg")}
                            className="svg-icon-danger"
                        />
                    );
                }
                if (value === "1") {
                    return (
                        <SVG
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen037.svg")}
                            className="svg-icon-valid"
                        />
                    );
                }
                if (value === "2") {
                    return (
                        <SVG
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen046.svg")}
                            className="svg-icon-warning"
                        />
                    );
                }
                return value;
            },
        },
    };
}

export function linksColumn() {
    return {
        filter: "agTextColumnFilter",
        valueGetter: ({ data }: any) =>
            data?.links
                ? data.links[1]
                    ? `${data.links[0].url} (${data.links[0].anchor})\n ${data.links[1].url} (${data.links[1].anchor})`
                    : `${data.links[0].url} (${data.links[0].anchor})`
                : "",
        cellRenderer: ({ data }: any) => <CellLinks links={data.links} />,
    };
}
